var $=jQuery;
$(function() {
// -------------视频播放---------------

// 图标链接
const playIcon2 = 'https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_f3e3ab4c-d6e0-437e-a16b-bdbeb228a726.png?v=1751457002';
// const pauseIcon = 'https://cdn.shopify.com/s/files/1/1720/3969/files/Frame-1_0b332839-8ef3-4d22-b93c-5388189c7cd1.png?v=1751457040';

// 播放按钮点击：播放/暂停切换

// ----====-==
const productItemLi = document.querySelectorAll(".product__media-wrapper ul li.product__media-item");

console.log('绑定的视频数量:', productItemLi.length);

// 播放/暂停及控件事件绑定

productItemLi.forEach(function (li, index) {
    // console.log(`绑定第${index + 1}个 li`, li);
  const video = li.querySelector('video');
  if (!video) return;
  const playBtn = li.querySelector('.playBtn');
  // const videoSound = li.querySelector('.videoMuteSoundButton .iconfont');
  const videoControls = li.querySelector('.pos.video-controls');
  const progressBar = li.querySelector('.progressBar'); // 进度条宽度控制元素
  const videoSound = li.querySelector('.videoMuteSoundButton .iconfont'); // ✅ 补上定义

  // console.log(`第${index + 1}个 li`, { video, playBtn, videoSound, videoControls, progressBar });
  if (window.innerWidth < 789 && video) {  }
  // console.log("打印下视频元素", video);
  
    video.removeAttribute('controls');  
    
  if (window.innerWidth < 789) { }
    document.querySelectorAll('.VideoWrapper .pos.video-controls ').forEach(img => {
      // console.log('获取中间播放按钮更改属性');
      img.style.display = 'block';
    });
 
  

  // 静音按钮点击事件 详情 m+pc , 加购弹窗 pc 
  // -=----=-=-=-=-=-1=-=-=-=-=-=-=-==-=-=-=-=
  //  // 静音按钮
  //  if (video && videoSound) {
  //   videoSound.addEventListener('click', function (event) {
  //     event.stopPropagation();
  //     video.muted = !video.muted;
  //     videoSound.classList.toggle('icon-a-Property1volume-x', video.muted);
  //     videoSound.classList.toggle('icon-icon', !video.muted);
  //   });
  // }
  // -=----=-=-=-=-=-2=-=-=-=-=-=-=-==-=-=-=-=
  // if (video && videoSound) {
    
  //   videoSound.addEventListener('click', function (event) {
  //     event.stopPropagation(); // 阻止事件冒泡，防止触发播放
  //     video.muted = !video.muted;
  //     if (video.muted) { console.log("声音触发，测试1关闭");
  //       videoSound.classList.remove('icon-icon');
  //       videoSound.classList.add('icon-a-Property1volume-x');
  //     } else { console.log("声音触发，测试2打开");
  //       videoSound.classList.remove('icon-a-Property1volume-x');
  //       videoSound.classList.add('icon-icon');
  //     }
  //   });
  // }

  // -=----=-=-=-=-=-3=-=-=-=-=-=-=-==-=-=-=-=
    // 静音按钮点击事件（统一控制所有视频）
  if (video && videoSound) {
    videoSound.addEventListener('click', function (event) {
      event.stopPropagation(); // 阻止冒泡

      // 获取当前点击视频的静音状态，作为全局状态
      const newMutedState = !video.muted;

      // 遍历所有 li 里的 video 和按钮
      productItemLi.forEach(function (li) {
        const v = li.querySelector('video');
        const btn = li.querySelector('.videoMuteSoundButton .iconfont');

        if (v) {
          v.muted = newMutedState;
        }
        if (btn) {
          if (newMutedState) {
            // 全部静音
            btn.classList.remove('icon-icon');
            btn.classList.add('icon-a-Property1volume-x');
          } else {
            // 全部开启声音
            btn.classList.remove('icon-a-Property1volume-x');
            btn.classList.add('icon-icon');
          }
        }
      });

      if (newMutedState) {
        console.log("🔇 全部视频静音");
      } else {
        console.log("🔊 全部视频开启声音");
      }
    });
  }


  // -=----=-=-=-=-=-end=-=-=-=-=-=-=-==-=-=-=-=


 
  




  // 进度条更新
  if (video && progressBar) {
    video.addEventListener('timeupdate', function () {
      const percentage = (video.currentTime / video.duration) * 100;
      progressBar.style.width = percentage + '%';
    });
  }
});

// 离开视口检测暂停 - 使用一个统一的 IntersectionObserver 监听所有 li
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        const li = entry.target;
        const video = li.querySelector('video');
        const playBtn = li.querySelector('.playBtn');
        const videoSound = li.querySelector('.videoMuteSoundButton .iconfont');

        if (video && !video.paused) {
          video.pause();
          console.log('视频离开视口自动暂停');
        }
        if (playBtn) playBtn.src = playIcon2;
        if (videoSound) videoSound.style.display = 'block';
      }
    });
  }, {
    threshold: 0.1
  });

  // 观察所有 li 元素
  productItemLi.forEach(li => observer.observe(li));
}

// ------------产品详情M端轮播条----------------
const mediaItems = document.querySelectorAll('.product__media-list li');
const indexIndicators = document.querySelectorAll('.product-media-left-img-index .img-index');
const picMunBer = document.querySelectorAll('.pic_mun_left_pos .now_pic_num');

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const currentPosition = entry.target.getAttribute('data-media-position');

        // 移除所有 active 类
        indexIndicators.forEach(indicator => {
          indicator.classList.remove('active');
        });

        // 给对应位置添加 active
        const currentIndicator = document.querySelector(`.img-index[data-media-position="${currentPosition}"]`);
        console.log(currentIndicator, '当前轮播条被激活了');
          if (picMunBer && picMunBer.length > 0) {
            picMunBer.forEach(el => {
              el.textContent = currentPosition;
            });
          }
        
        
        if (currentIndicator) {
          currentIndicator.classList.add('active');
        }
      }
    });
  }, {
    threshold: 0.6 // 控制触发时机，元素进入视口 60% 以上时触发 
  });

  mediaItems.forEach(item => observer.observe(item));
}
// ------------轮播条被点击-------------------

// const indexIndicators = document.querySelectorAll('.index-indicator'); // 替换为你的指示器类名
indexIndicators.forEach(function (el) {
  el.addEventListener('click', function () {
    console.log('点击了轮播条', this, el);

    const position = this.getAttribute('data-media-position');
    const targetMedia = document.querySelector(
      `use-animate ul li[data-media-position="${position}"]`
    );

    if (targetMedia) {
      targetMedia.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    } else {
      console.warn('找不到目标 media 元素');
    }
  });
});


})
// ------------+ 触发弹出产品主图 +-------------------
